// 请求手机充值页面
import axiosRequest from '@/utils/request'

export const phoneRechargePage = (params) => {
  return axiosRequest({
    url: '/wallet/phone-recharge-page',
    method: 'get',
    params
  })
}

// 手机充值PAY-NOW接口
export const phoneRechargePayNow = (data) => {
  return axiosRequest({
    url: '/wallet/phone-recharge-pay-now',
    method: 'post',
    data
  })
}
// 话费充值
export const topUp = (data) => {
  return axiosRequest({
    url: '/utilities/top-up',
    method: 'post',
    data,
    showMessage: false
  })
}
// 交易详情
export const topUpDetail = (data) => {
  return axiosRequest({
    url: '/utilities/top-up-detail',
    method: 'post',
    data
  })
}
